module.exports = __webpack_public_path__ + "img/03uni-doll.33c2fbcf.png";